import './for-order.styles.scss';

const ForOrder = () => {
  return (
    <div id='for-order2' className='team-section-for-order'>
      <div className='container'>
        <div className='for-order-title'>Для Замовлення</div>
        <div className='team-card'>
          <div className='card image-section-one'>
            <div className=''>
              <div className='content'>
                <h3>Ваш вибір</h3>
                <div className='for-order-white-line'></div>
                <p>
                  Перше. Найважливіше. Оберіть модель меблів у галереї вище.
                  Звертайте увагу на розміри та матеріали. Розуміємо, по фото
                  важко інколи оцінити якість, тому ви завжди можете зв'язатися
                  з нами через соц. мережі або по телефону.
                </p>
              </div>
            </div>
          </div>
          <div className='card image-section-two'>
            <div className=''>
              <div className='content'>
                <h3>Знайомство</h3>
                <div className='for-order-white-line'></div>
                <p>
                  Заповніть будь ласка анкету нижче. Здається що це
                  формальність, кілька простих питань. Але кожен споживач
                  важливий для нас. Тому, приємно познайомитись!
                </p>
              </div>
            </div>
          </div>
          <div className='card image-section-three'>
            <div className=''>
              <div className='content'>
                <h3>Наша Справа</h3>
                <div className='for-order-white-line'></div>

                <p>
                  Після отримання анкети ми телефонуємо до Вас для уточнення
                  деталей замолення. Після цього максимально швидко відправляємо
                  меблі і вуаля, ви вже п'єте каву сидячи за новим столом.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForOrder;
